import { getSessionStorage, setSessionStorage } from '@/utils/sessionStorage'
import { useEffect } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { mapTermsToPrimaryFocus } from '@/domain/term/useCases/mapTermsToPrimaryFocus'
const useFetchAndStorePrimaryFocusMap = () => {
  const data = useStaticQuery(graphql`
    query {
      primaryFocusTerms: allTaxonomy(filter: { primaryFocus: { ne: null } }) {
        edges {
          node {
            title
            slug
            primaryFocus
          }
        }
      }
    }
  `)

  useEffect(() => {
    if (!getSessionStorage('primaryFocusMap')) {
      const primaryFocusMap = mapTermsToPrimaryFocus(
        data.primaryFocusTerms.edges
      )
      setSessionStorage('primaryFocusMap', primaryFocusMap)
    }
  }, [])
}

export default useFetchAndStorePrimaryFocusMap
